import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { EventItem } from "./EventItem";

export const Events = () => {
  const [events, setEvents] = useState(null);

  useEffect(() => {
    axios.get(`${API}/events`).then((r) => setEvents(r.data)).catch(() => setEvents([]));
  }, []);

  return (
    <section className="sec" id="events" data-testid="events-section">
      <div className="wrap">
        <div className="head">
          <h2>Events</h2>
          <p>Resource festivals, donation drives, and outreach that bring neighbors and partner organizations together.</p>
        </div>
        {events === null && <p className="events-loading" data-testid="events-loading">Loading upcoming events…</p>}
        {events?.length === 0 && (
          <div className="no-events" data-testid="no-events-message">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /></svg>
            <div>
              <strong>No upcoming events — check back soon</strong>
              <span>We're planning our next gathering. Follow @DavisInfiniteCare or <a href="#contact">reach out</a> to hear about it first.</span>
            </div>
          </div>
        )}
        {events?.map((ev) => <EventItem key={ev.id} event={ev} />)}
      </div>
    </section>
  );
};
